import { render, staticRenderFns } from "./Son10Siparis.vue?vue&type=template&id=3a19ef5e&scoped=true"
import script from "./Son10Siparis.vue?vue&type=script&lang=js"
export * from "./Son10Siparis.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a19ef5e",
  null
  
)

export default component.exports